export const TRIBE_PRESENTATION_HINT_KEY = 'aztec-realms:tribe-id';

const tribeRoles = new Set(['member', 'veteran', 'officer', 'leader']);

interface TribeIdentity {
  id: string;
  current_user_role: string | null;
}

interface CurrentTribeAuthority<T extends TribeIdentity> {
  active: boolean;
  role: string | null;
  tribe: T | null;
}

type PresentationHintStorage = Pick<Storage, 'removeItem' | 'setItem'>;

export function resolveAuthoritativeCurrentTribe<T extends TribeIdentity>(
  authority: CurrentTribeAuthority<T>,
  hintStorage?: PresentationHintStorage,
): T | undefined {
  const role = authority.role;
  const tribe = authority.tribe;
  if (
    !authority.active ||
    !role ||
    !tribeRoles.has(role) ||
    !tribe ||
    tribe.current_user_role !== role
  ) {
    hintStorage?.removeItem(TRIBE_PRESENTATION_HINT_KEY);
    return undefined;
  }
  hintStorage?.setItem(TRIBE_PRESENTATION_HINT_KEY, tribe.id);
  return tribe;
}
